import $ from "jquery";
import jqueryUi from 'jquery-ui';
import angular from 'angular';
import ngRoute from 'angular-route';
import uiRouter from 'angular-ui-router';
import restangular from 'restangular';
import lodash from 'lodash';
import underscore from 'underscore';
import hammer from 'hammerjs';
import angularHammer from 'angular-hammer';
import ngCookies from 'angular-cookies';
import pickADate from 'ng-pickadate';
import angularUuid from 'angular-uuid';
import ngScroll from './lib/ngscroll';
//import Raven from 'raven-js';
//import ngRaven from 'raven-js/plugins/angular';
import angucomplete from './lib/directive/angucomplete';
import uiSortable from 'angular-ui-sortable';
import ngMaterial from 'angular-material';
import mdPickers from 'mdPickers';
import ngFileUpload from 'ng-file-upload';
import ngSanitize from 'angular-sanitize';
import geo from 'angularjs-geolocation';
import mdDataTable from 'angular-material-data-table';
import chartJs from 'chart.js';
import angularChartJs from 'angular-chart.js';
import creditCard from './lib/angular-credit-cards';
import dragDrop from 'angular-dragdrop';
import ngSortable from 'ng-sortable';
import moment from 'moment-timezone';
import touchPunch from 'jquery-ui-touch-punch';
import angularObjectDiff from 'angular-object-diff';
import mdDateRangePicker from 'md-date-range-picker';
import stringSimilarity from 'string-similarity';

/*Raven.config("https://109b69b91e1d4abfaff2e8a913008d65@sentry.docketbook.io/2").addPlugin(ngRaven).install();
window.configureRaven = (function (dsn) {
  Raven.setDSN(dsn);
});*/

window.redirectToLogout = () => {
  window.location = `${DOCKETBOOK_API_URL}/v1/logout`;
};

const circularstdbold = require('./fonts/circularstd-bold-webfont.ttf');
const circularstdbook = require('./fonts/circularstd-book-webfont.ttf');
const circularstdmedium = require('./fonts/circularstd-medium-webfont.ttf');

const companySettingsWhite = require('./images/companySettingsWhite.svg');
const squareMaskBg = require('./images/_square-mask.svg');
const fileDownload = require('./images/file_download.svg');
const magnifySvg = require('./images/magnify.svg');
const clearSvg = require('./images/clear.svg');
const arrowDownSvg = require('./images/arrow_down.svg');
const arrowUpSvg = require('./images/arrow_up.svg');
const menuSvg = require('./images/menu.svg');
const dbLogomark = require('./images/db-logomark.svg');
const account = require('./images/account.svg');
const logout = require('./images/logout.svg');
const help = require('./images/help.svg');
const settings = require('./images/_settings.svg');
const companysettings = require('./images/companysettings.svg');
const dash = require('./images/dashboard.svg');
const folder = require('./images/folder.svg');
const job = require('./images/job.svg');
const desc = require('./images/description.svg');
const err = require('./images/error.svg');
const left = require('./images/left.svg');
const userGroup = require('./images/user-group.svg');
const adminUser = require('./images/admin-user.svg');
const eye = require('./images/eye.svg');
const creditCardSvg = require('./images/credit-card.svg');
const roles = require('./images/roles.svg');
const templatedesigner = require('./images/templatedesigner.svg');
const fields = require('./images/fields.svg');
const checklist = require('./images/checklist.svg');
const archive = require('./images/archive.svg');
const truck = require('./images/truck.svg');
const category = require('./images/category.svg');
const unit = require('./images/unit.svg');
const org = require('./images/org.svg');
const deleteSvg = require('./images/delete.svg');
const noteAdd = require('./images/note_add.svg');
const reload = require('./images/reload.svg');
const moreVert = require('./images/more-vert.svg');
const add = require('./images/add.svg');
const copy = require('./images/copy.svg');
const arrowLeft = require('./images/arrow_left.svg');
const textField = require('./images/text-field.svg');
const multilineField = require('./images/multiline-field.svg');
const switchField = require('./images/_switch.svg');
const numberField = require('./images/number-field.svg');
const clockField = require('./images/clock.svg');
const calendar = require('./images/calendar.svg');
const selectField = require('./images/_select-field.svg');
const edit = require('./images/edit.svg');
const importSvg = require('./images/import.svg');
const filterSvg = require('./images/filter.svg');
const lines = require('./images/lines.svg');
const report = require('./images/report.svg');
const expand_more = require('./images/expand_more.svg');
const contactshare = require('./images/_contactshare.svg');
const forum = require('./images/forum.svg');
const otherMoreVert = require('./images/more_vert.svg');
const location = require('./images/location.svg');
const drag = require('./images/drag.svg');
const successtick = require('./images/_successtick.svg');
const signature = require('./images/_signature.svg');
const customSection = require('./images/custom-section.svg');
const checklistsAlt = require('./images/checklist-alt.svg');
const font = require('./images/font.svg');
const resourcesave = require('./images/resourcesave.svg');
const dumpTruck = require('./images/dump-truck.svg');
const nextIcon = require('./images/next-icon.svg');
const backIcon = require('./images/back-icon.svg');
const calendar2 = require('./images/calendar2.svg');
const allocate = require('./images/allocate.svg');
const errorOutline = require('./images/error-outlined.svg')
const padlock = require('./images/padlock.svg');
const numOrgsImage = require('./images/organisations.svg');
const xeroConnect = require('./images/xero-connect-white.svg');
const xeroDisconnect = require('./images/xero-disconnect-white.svg');
const accountMultiple = require('./images/account-multiple.svg');
const domain = require('./images/domain.svg');
const newDocument = require('./images/file-document.svg');

const timesheetsPaywalled = require('./images/timesheets-paywall-illustration.svg')
const jobsPaywalled = require('./images/jobs-paywall-illustration.svg')
const ordersPaywalled = require('./images/orders-paywall-illustration.svg')

const card1 = require('./images/cardTypes/1.png');
const card2 = require('./images/cardTypes/2.png');
const card22 = require('./images/cardTypes/22.png');
const card14 = require('./images/cardTypes/14.png');
const card10 = require('./images/cardTypes/10.png');
const card16 = require('./images/cardTypes/16.png');

const favicon1616 = require('./images/favicon-16x16.png');
const favicon3232 = require('./images/favicon-32x32.png');
const favicon9696 = require('./images/favicon-96x96.png');

const appleIcon5757 = require('./images/apple-icon-57x57.png');
const appleIcon6060 = require('./images/apple-icon-60x60.png');
const appleIcon7272 = require('./images/apple-icon-72x72.png');
const appleIcon7676 = require('./images/apple-icon-76x76.png');
const appleIcon114114 = require('./images/apple-icon-114x114.png');
const appleIcon120120 = require('./images/apple-icon-120x120.png');
const appleIcon144144 = require('./images/apple-icon-144x144.png');
const appleIcon152152 = require('./images/apple-icon-152x152.png');
const appleIcon180180 = require('./images/apple-icon-180x180.png');
const androidIcon192192 = require('./images/android-icon-192x192.png');
//const mainTemplate = require('ngtemplate-loader!html-loader!./views/mainTemplate.html');

const lineOkIcon = require('./images/check.svg');
const lineWarningIcon = require('./images/warningline.svg');

const mainTemplate = require('./views/mainTemplate');
const settingsTemplate = require('./views/settingsTemplate');
const loading = require('./views/loading');
const alertTemplate = require('./views/alerts/alertTemplate');
const slider = require('./views/notifications/slider');
const selectContactModal = require('./views/modals/selectContactModal');
const selectQuoteModal = require('./views/modals/selectQuoteModal');
const editContactModal = require('./views/modals/editContactModal');
const viewMessageModal = require('./views/modals/viewMessageModal');
const selectOrgUnitModal = require('./views/modals/selectOrgUnitModal');
const home = require('./views/pages/home');
const mainNav = require('./views/mainNav');
const scopeNav = require('./views/scopeNav');
const trialBanner = require('./views/trialBanner');
const editOrgModal = require('./views/modals/editOrgModal');
const waitToBeInvitedModal = require('./views/modals/waitToBeInvitedModal')
const userAccount = require('./views/pages/user/account');
const dashboard = require('./views/pages/dashboard');
const newGroupModal = require('./views/modals/newGroupModal');
const groupSettingsGeneral = require('./views/pages/companySettings/general');
const companySettingsNav = require('./views/pages/companySettings/nav');
const searchAbnModal = require('./views/modals/searchAbnModal');
const editBankAccountModal = require('./views/modals/editBankAccountModal')
const xeroConnectModal = require('./views/modals/xeroConnect');
const selectRoleModal = require('./views/modals/selectRoleModal');
const inviteMembersModal = require('./views/modals/inviteMembersModal');
const editUserGroupRolesModal = require('./views/modals/editUserGroupRolesModal');
const selectPersonModal = require('./views/modals/selectPersonModal');
const groupSettingsAdmins = require('./views/pages/groupSettings/admins');
const groupSettingsFiling = require('./views/pages/groupSettings/filing');
const companySettingsBilling = require('./views/pages/companySettings/billing');
const selectPlanModal = require('./views/modals/selectPlanModal');
const companySettingsRoles = require('./views/pages/companySettings/roles');
const companySettingsTemplates = require('./views/pages/companySettings/templates');
const companySettingsGroups = require('./views/pages/companySettings/groups');
const companySettingsUsers = require('./views/pages/companySettings/users');
const docketDesigner = require('./views/pages/docketDesigner/designer');
const fieldModal = require('./views/modals/fieldModal');
const checklistModal = require('./views/modals/checklistModal');
const companySettingsFields = require('./views/pages/companySettings/fields');
const companySettingsChecklists = require('./views/pages/companySettings/checklists');
const companySettingsResources = require('./views/pages/companySettings/resources');
const editResourceModal = require('./views/modals/editResourceModal');
const companySettingsCategories = require('./views/pages/companySettings/categories');
const companySettingsUoms = require('./views/pages/companySettings/uoms');
const editUserModal = require('./views/modals/editUserModal')
const importContactsModal = require('./views/modals/importContactsModal')
const importResourcesModal = require('./views/modals/importResourcesModal')
const exportDocketsLockedPage = require('./views/pages/paywalled/exportDockets')
const trailActivatedModal = require('./views/modals/trialActivatedModal');

const desktopOrders = require('./views/pages/orders/desktop/index');
const desktopOrdersHeading = require('./views/pages/orders/desktop/ordersHeading');
const desktopOrdersList = require('./views/pages/orders/desktop/ordersList');
const shareOrderModal = require('./views/modals/shareOrderModal');
const assignOrderModal = require('./views/modals/assignOrderModal');
const acceptOrderWizardModal = require('./views/modals/acceptOrderWizardModal');
const recommendLineItemResourceModal = require('./views/modals/recommendLineItemResourceModal')
const sorryToSeeYouGoModal = require('./views/modals/sorryToSeeYouGoModal')
const cancellationConfirmedModal = require('./views/modals/cancellationConfirmedModal')

const selectResourceModal = require('./views/modals/selectResourceModal');
const selectTemplateModal = require('./views/modals/selectTemplateModal');

const orderDesktopDetail = require('./views/pages/orders/desktop/orderDetail');
const orderDesktopOrderTab = require('./views/pages/orders/desktop/orderTab');
const orderDesktopJobsTab = require('./views/pages/orders/desktop/jobsTab');
const orderDesktopDocketsTab = require('./views/pages/orders/desktop/docketsTab');
const orderDesktopAuditLogTab = require('./views/pages/orders/desktop/auditLogTab');

const desktopJobs = require('./views/pages/jobs/desktop/index');
//const desktopJobsHeading = require('./views/pages/jobs/desktop/jobsHeading');
const desktopJobsHeading = require('./views/pages/jobs/desktop/jobsHeading');
const desktopJobsList = require('./views/pages/jobs/desktop/jobsList');
const shareJobModal = require('./views/modals/shareJobModal');
const paywalledJobsPage = require('./views/pages/paywalled/jobs')
const paywalledTimesheetsPage = require('./views/pages/paywalled/timesheets')
const paywalledOrdersPage = require('./views/pages/paywalled/orders')

const selectLineModal = require('./views/modals/selectLineModal');

const duplicateJobsModal = require('./views/modals/duplicateJobsModal');
const jobCommentModal = require('./views/modals/jobCommentModal');
const selectOrderModal = require('./views/modals/selectOrderModal');

const desktopJobsDetail = require('./views/pages/jobs/desktop/jobDetail');
const desktopJobsTab = require('./views/pages/jobs/desktop/jobTab');
const desktopJobsDocketsTab = require('./views/pages/jobs/desktop/docketsTab');
const desktopJobsAuditLogTab = require('./views/pages/jobs/desktop/auditLogTab');

const desktopDockets = require('./views/pages/dockets/desktop/index');
const desktopDocketsHeading = require('./views/pages/dockets/desktop/docketsHeading');
const desktopDocketsList = require('./views/pages/dockets/desktop/docketsList');

const docketSummaryReportModal = require('./views/modals/docketSummaryReportModal');
const rejectDocketModal = require('./views/modals/rejectDocketModal');
const docketBatchModal = require('./views/modals/docketBatch');
const shareDocketModal = require('./views/modals/shareDocketModal');
const assignDocketModal = require('./views/modals/assignDocketModal');
const selectJobModal = require('./views/modals/selectJobModal');
const selectXeroContactModal = require('./views/modals/selectXeroContactModal');
const desktopInteractionModal = require('./views/modals/desktopInteractionModal');
const signatureCaptureModal = require('./views/modals/signatureCaptureModal');
const checklistDetailModal = require('./views/modals/checklistDetailModal');
const acceptConnectionRequestModal = require('./views/modals/acceptConnectionRequestModal')
const createConnectionModal = require('./views/modals/createConnectionModal')

const filingDesktop = require('./views/pages/filing/desktop/index');
const filingDesktopHeading = require('./views/pages/filing/desktop/filingHeading');
const filingDesktopList = require('./views/pages/filing/desktop/filingList');
const filingDesktopDetail = require('./views/pages/filing/desktop/filingDetail.html');

const batchList = require('./views/pages/batches/batchList');
const batchDetail = require('./views/pages/batches/batchDetail');

const xeroInvoiceModal = require('./views/modals/xeroInvoice');
const docketDesktopDetail = require('./views/pages/dockets/desktop/docketDetail');
const docketDesktopFilingTab = require('./views/pages/dockets/desktop/filingTab');
const docketDesktopGeneralTab = require('./views/pages/dockets/desktop/generalTab');
const docketDesktopGeneralTabPreAuth = require('./views/pages/dockets/desktop/generalTabPreAuth');
const docketDesktopAttachmentsTab = require('./views/pages/dockets/desktop/attachmentsTab');
const docketDesktopAuditLogTab = require('./views/pages/dockets/desktop/auditLogTab');
const docketDesktopMapTab = require('./views/pages/dockets/desktop/mapTab');
const fileCodeReportModal = require('./views/modals/fileCodeReportModal');

const contacts = require('./views/pages/contacts/contacts');
const shareContactModal = require('./views/modals/shareContactModal');
const connections = require('./views/pages/connections/connections');

const mobileListsMaster = require('./views/pages/mobileLists/listsMaster');
const mobileListsHeader = require('./views/pages/mobileLists/listsHeader');
const mobileListsFooter = require('./views/pages/mobileLists/listsFooter');
const docketMobileList = require('./views/pages/dockets/mobile/list');
const jobMobileList = require('./views/pages/jobs/mobile/list');
const ordersMobileList = require('./views/pages/orders/mobile/list');
const filingMobileList = require('./views/pages/filing/mobile/list');

const docketMobileDetail = require('./views/pages/dockets/mobile/detail');
const organisationListSelector = require('./views/selectors/organisationList');
const docketMobileTabBar = require('./views/pages/dockets/mobile/mobileTabBar');
const docketMobileDetailOther = require('./views/pages/dockets/mobile/docketDetail');
const docketMobileBottomSheet = require('./views/pages/dockets/mobile/docketsBottomSheet');
const companyListSelector = require('./views/selectors/companyList');
const viewContactModal = require('./views/modals/viewContactModal');
const orderListSelector = require('./views/selectors/orderList');
const templateListSelector = require('./views/selectors/templateList');
const resourceCategoryListSelector = require('./views/selectors/resourceCategoryList');
const resourceListSelector = require('./views/selectors/resourceList');
const mobileInteractionModal = require('./views/modals/mobileInteractionModal');
const docketMobileGeneralTab = require('./views/pages/dockets/mobile/generalTab');
const docketMobileAttachmentsTab = require('./views/pages/dockets/mobile/attachmentsTab');
const docketMobileItemsTab = require('./views/pages/dockets/mobile/itemsTab');
const docketMobileSignaturesTab = require('./views/pages/dockets/mobile/signaturesTab');
const docketMobileCustomBlockTab = require('./views/pages/dockets/mobile/customBlockTab');
const docketMobileChecklistsTab = require('./views/pages/dockets/mobile/checklistsTab');
const docketMobileTimeTab = require('./views/pages/dockets/mobile/timeTab');

const orderMobileDetail = require('./views/pages/orders/mobile/detail');
const orderMobileTabBar = require('./views/pages/orders/mobile/mobileTabBar');
const orderMobileOrderDetail = require('./views/pages/orders/mobile/orderDetail');
const orderMobileGeneralTab = require('./views/pages/orders/mobile/generalTab');
const orderMobileLineItemsTab = require('./views/pages/orders/mobile/lineItemsTab');
const orderMobileJobsTab = require('./views/pages/orders/mobile/jobsTab');
const orderMobileDocketsTab = require('./views/pages/orders/mobile/docketsTab');
const mobileLineItemModal = require('./views/modals/mobileLineItemModal');
const orderMobileBottomSheet = require('./views/pages/orders/mobile/ordersBottomSheet');
const importResourceFromFile = require('./views/modals/importResourceFromFile')

const jobMobileDetail = require('./views/pages/jobs/mobile/detail');
const jobMobileTabBar = require('./views/pages/jobs/mobile/mobileTabBar');
const jobMobileDetailDetail = require('./views/pages/jobs/mobile/jobDetail');
const personListSelector = require('./views/selectors/personList');
const lineItemListSelector = require('./views/selectors/lineItemList');

const jobMobileGeneralTab = require('./views/pages/jobs/mobile/generalTab');
const jobMobileLineItemsTab = require('./views/pages/jobs/mobile/lineItemsTab');
const jobMobileDocketsTab = require('./views/pages/jobs/mobile/docketsTab');
const jobMobileCommentsTab = require('./views/pages/jobs/mobile/commentsTab');
const jobMobileAssigneesTab = require('./views/pages/jobs/mobile/assigneesTab');
const jobMobileBottomSheet = require('./views/pages/jobs/mobile/jobsBottomSheet');

const filingMobileDetail = require('./views/pages/filing/mobile/detail');
const activityListSelector = require('./views/selectors/activityList');

const mobileSideNav = require('./views/pages/mobileSideNav');

const preAuthTemplate = require('./views/preAuthTemplate');
const preAuthDocket = require('./views/pages/preauth/docket');

const groupSettingsNav = require('./views/pages/groupSettings/nav.html');

const addressBookTags = require('./views/pages/companySettings/addressBookTag.html');
const selectContactTagsModal = require('./views/modals/selectContactTagModal.html');
const assignJobModal = require('./views/modals/assignJobModal.html');

const timesheetsDesktopPage = require('./views/pages/timesheets/desktop/index.html');
const timesheetsHeader = require('./views/pages/timesheets/desktop/timesheetsHeading.html');

const selectOrderLineModal = require('./views/modals/selectOrderLine.html');

const ordersFilterBar = require('./views/filterBars/ordersFilterBar.html')
const docketsFilterBar = require('./views/filterBars/docketsFilterBar.html')
const jobsFilterBar = require('./views/filterBars/jobsFilterBar.html')

angular.module('docketbook', [
  'ngRoute',
  'ui.router',
  'restangular',
  'hmTouchEvents',
  'ngCookies',
  'pickadate',
  'angular-uuid',
  'ngScroll',
  //'ngRaven',
  'angucomplete',
  'ui.sortable',
  'ngMaterial',
  'mdPickers',
  'ngFileUpload',
  'ngSanitize',
  'geolocation',
  'md.data.table',
  'chart.js',
  'ngFileUpload',
  'credit-cards',
  'ngDragDrop',
  'as.sortable',
  'ds.objectDiff',
  'ngMaterialDateRangePicker'
]).config(['$routeProvider', '$urlRouterProvider', '$stateProvider', '$httpProvider', '$mdThemingProvider', '$mdDateLocaleProvider', '$sceDelegateProvider', 'RestangularProvider', function ($routeProvider, $urlRouterProvider, $stateProvider, $httpProvider, $mdThemingProvider, $mdDateLocaleProvider, $sceDelegateProvider, RestangularProvider) {


  $urlRouterProvider.otherwise('/dashboard');
  $sceDelegateProvider.resourceUrlWhitelist([
    // Allow same origin resource loads.
    'self',
    // Allow loading from our assets domain.  Notice the difference between * and **.
    'https://dbcdn.global.ssl.fastly.net/**'
  ]);
  $mdDateLocaleProvider.formatDate = function (date) {
    return date ? moment(date).format('DD/MM/YYYY') : '';
  };

  $mdDateLocaleProvider.parseDate = function (dateString) {
    var m = moment(dateString, 'DD/MM/YYYY', true);
    return m.isValid() ? m.toDate() : new Date(NaN);
  };

  RestangularProvider.setDefaultHttpFields({
    withCredentials: true,
  });
  RestangularProvider.setBaseUrl(`${DOCKETBOOK_API_URL}/v1/`);

  var docketbookBlue = $mdThemingProvider.extendPalette('light-blue', {
    '500': '#222961',
    'contrastDefaultColor': 'light',
    'contrastLightColors': ['500']
  });

  $mdThemingProvider.definePalette('docketbookBlue', docketbookBlue);

  $mdThemingProvider.theme('default')
    .primaryPalette('docketbookBlue', {
      'default': '500'
    })
    .accentPalette('docketbookBlue', {
      'default': '500'
    });

  var docketbookDarkBlue = $mdThemingProvider.extendPalette('grey', {
    '500': '#042B42',
    'contrastDefaultColor': 'light',
    'contrastLightColors': ['500']
  });

  $mdThemingProvider.definePalette('docketbookDarkBlue', docketbookDarkBlue);

  $mdThemingProvider.theme('dbDarkBlue')
    .primaryPalette('docketbookDarkBlue', {
      'default': '500'
    })
    .accentPalette('docketbookDarkBlue', {
      'default': '500'
    });

  $httpProvider.interceptors.push(function ($q) {
    return {
      'responseError': function (rejection) {
        var defer = $q.defer();
        if (rejection.status == 401) {
          $("#sessionExpiredModal").fadeIn(100);
        }
        defer.reject(rejection);
        return defer.promise;
      }
    };
  });

  $stateProvider.state('main', {
    url: "",
    templateUrl: mainTemplate,
    abstract: true,

  }).state('main.dashboard', {
    url: "/dashboard?noredirect&redirectTo",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    data: {
      "mainnavOption": "dashboard",
      "pageTitle": "Home",
      "listView": "feed",
      "newCompany": "false"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/home.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'dashboardController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.companySelect', {
    url: "/companies",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    data: {
      "mainnavOption": "companies",
      "pageTitle": "Home",
      "listView": "feed",
      "newCompany": "false"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/home.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'dashboardController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupDashboard', {
    url: "/org/:orgId/group/:groupId/dashboard",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      orgId: undefined,
      groupId: undefined,
    },
    data: {
      "mainnavOption": "dashboard",
      "pageTitle": "Dashboard",
      "listView": "feed"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/dashboard.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'dashboardController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.orders', {
    url: "/orders",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: {
      active: undefined,
      test: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined,
      myDocketbook: true
    },
    data: {
      "mainnavOption": "orders",
      "pageTitle": "Orders",
      "listView": "orders"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/orders/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'ordersDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupOrders', {
    url: "/org/:orgId/group/:groupId/orders",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined,
      test: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined,
      status: undefined
    },
    data: {
      "mainnavOption": "orders",
      "pageTitle": "Orders",
      "listView": "orders"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/orders/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'ordersDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.orderDetail', {
    url: "/orders/:orderId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: {
      openTab: undefined,
      myDocketbook: true
    },
    data: {
      "mainnavOption": "orders",
      "pageTitle": "Orders"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/orders/mobile/detail.html';
          } else {
            return 'views/pages/orders/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'orderMobileDetailController';
          } else {
            return 'ordersDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupOrderDetail', {
    url: "/org/:orgId/group/:groupId/orders/:orderId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      openTab: undefined
    },
    data: {
      "mainnavOption": "orders",
      "pageTitle": "Orders"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/orders/mobile/detail.html';
          } else {
            return 'views/pages/orders/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'orderMobileDetailController';
          } else {
            return 'ordersDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.jobs', {
    url: "/jobs",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      myDocketbook: undefined,
      orderId: undefined,
      orderNumber: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined,
      myDocketbook: true
    },
    data: {
      "mainnavOption": "jobs",
      "pageTitle": "Jobs",
      "listView": "jobs"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/jobs/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'jobsDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupJobs', {
    url: "/org/:orgId/group/:groupId/jobs",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      myDocketbook: undefined,
      orderId: undefined,
      orderNumber: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined,
      status: undefined,
      assigneeStatus: undefined
    },
    data: {
      "mainnavOption": "jobs",
      "pageTitle": "Jobs",
      "listView": "jobs"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/jobs/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'jobsDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.jobDetail', {
    url: "/jobs/:jobId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: {
      fromOrder: undefined,
      openTab: undefined,
      fromTab: undefined,
      orderId: undefined,
      orderNumber: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined,
      myDocketbook: true
    },
    data: {
      "mainnavOption": "jobs",
      "pageTitle": "Jobs"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/jobs/mobile/detail.html';
          } else {
            return 'views/pages/jobs/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'jobMobileDetailController';
          } else {
            return 'jobsDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupJobDetail', {
    url: "/org/:orgId/group/:groupId/jobs/:jobId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      fromOrder: undefined,
      openTab: undefined,
      fromTab: undefined,
      orderId: undefined,
      orderNumber: undefined,
      fromDate: undefined,
      toDate: undefined,
      customerContact: undefined,
      supplierContact: undefined
    },
    data: {
      "mainnavOption": "jobs",
      "pageTitle": "Jobs"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/jobs/mobile/detail.html';
          } else {
            return 'views/pages/jobs/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'jobMobileDetailController';
          } else {
            return 'jobsDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.dockets', {
    url: "/dockets",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      fromJob: undefined,
      myDocketbook: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      myDocketbook: true
    },
    data: {
      "mainnavOption": "dockets",
      "pageTitle": "Dockets",
      "listView": "dockets"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'docketDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupDockets', {
    url: "/org/:orgId/group/:groupId/dockets",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      fromJob: undefined,
      myDocketbook: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      viewMode: 'dockets',
      status: undefined
    },
    data: {
      "mainnavOption": "dockets",
      "pageTitle": "Dockets",
      "listView": "dockets"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'docketDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupExportDockets', {
    url: "/org/:orgId/group/:groupId/dockets/export",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      fromJob: undefined,
      myDocketbook: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      viewMode: 'dockets',
      status: undefined
    },
    data: {
      "mainnavOption": "dockets",
      "pageTitle": "Dockets",
      "listView": "dockets"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/paywalled/exportDockets.html',
        controller: 'paywalledController'
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.docketDetail', {
    url: "/dockets/:docketId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      fromJob: undefined,
      fromTab: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      myDocketbook: true
    },
    data: {
      "mainnavOption": "dockets",
      "pageTitle": "Dockets"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/dockets/mobile/detail.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'docketMobileDetailController';
          } else {
            return 'docketDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupDocketDetail', {
    url: "/org/:orgId/group/:groupId/dockets/:docketId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined,
      fromOrder: undefined,
      fromJob: undefined,
      fromTab: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      editing: undefined,
      author: undefined,
      authorName: undefined
    },
    data: {
      "mainnavOption": "dockets",
      "pageTitle": "Dockets"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/dockets/mobile/detail.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'docketMobileDetailController';
          } else {
            return 'docketDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('main.groupBatches', {
    url: "/org/:orgId/group/:groupId/batches",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      fromTab: undefined,
      docketId: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      viewMode: 'batch',
      action: undefined
    },
    data: {
      "mainnavOption": "dockets",
      "subnavOption": "batches",
      "pageTitle": "Batches",
      "listView": "batches"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'docketDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupBatchDetail', {
    url: "/org/:orgId/group/:groupId/batches/:batchId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      fromTab: undefined,
      docketId: undefined,
      orderId: undefined,
      orderNumber: undefined,
      jobId: undefined,
      jobNumber: undefined,
      viewMode: 'batch',
      action: undefined
    },
    data: {
      "mainnavOption": "dockets",
      "subnavOption": "batches",
      "pageTitle": "Batches",
      "listView": "batches"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'views/pages/mobileLists/listsMaster.html';
          } else {
            return 'views/pages/dockets/desktop/index.html';
          }
        },
        controllerProvider: function ($stateParams) {
          if ($stateParams.device == 'mobile') {
            return 'mobileListController';
          } else {
            return 'docketDesktopController';
          }
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupTimesheets', {
    url: "/org/:orgId/group/:groupId/timesheets",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      active: undefined
    },
    data: {
      "mainnavOption": "timesheets",
      "pageTitle": "Timesheets",
      "listView": "timesheets"
    },
    views: {
      'content': {
        templateUrl: function ($stateParams) {
          return 'views/pages/timesheets/desktop/index.html';
        },
        controllerProvider: function ($stateParams) {
          return 'timesheetsDesktopController';
        }
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.loading', {
    url: "/loading",
    params: {
      "goToState": undefined,
      "goToParams": undefined,
      "searchParams": undefined,
      'requestedUrl': undefined,
      'redirectTo': undefined,
    },
    views: {
      'content': {
        templateUrl: loading,
        controller: 'loadingController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('companySettings', {
    url: "",
    templateUrl: 'views/settingsTemplate.html',
    abstract: true
  }).state('companySettings.general', {
    url: "/org/:orgId/settings",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    params: {
      action: null
    },
    data: {
      "mainnavOption": "companySettings",
      "subnavOption": "general",
      "pageTitle": "Company Settings"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/general.html',
        controller: 'groupSettingsGeneralController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.groups', {
    url: "/org/:orgId/settings/groups",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Groups",
      "subnavOption": "groups",
      "orgOption": "groups"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/groups.html',
        controller: 'companySettingsGroupsController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.users', {
    url: "/org/:orgId/settings/users",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Users",
      "subnavOption": "users",
      "orgOption": "users"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/users.html',
        controller: 'companySettingsUsersController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.billing', {
    url: "/org/:orgId/settings/billing",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Billing Settings",
      "subnavOption": "billing",
      "orgOption": "billing"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/billing.html',
        controller: 'companySettingsBillingController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.roles', {
    url: "/org/:orgId/settings/roles",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Roles",
      "subnavOption": "roles",
      "orgOption": "roles"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/roles.html',
        controller: 'companySettingsRolesController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.templates', {
    url: "/org/:orgId/settings/templates",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Templates",
      "subnavOption": "templates",
      "docketsOption": "templates"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/templates.html',
        controller: 'companySettingsTemplatesController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('docketDesigner', {
    url: "/org/:orgId/settings/templates/:templateId",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    params: {
      "mode": ""
    },
    templateUrl: 'views/pages/docketDesigner/designer.html',
    controller: 'docketDesignerController'
  }).state('companySettings.fields', {
    url: "/org/:orgId/settings/fields",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Fields",
      "subnavOption": "fields",
      "docketsOption": "fields"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/fields.html',
        controller: 'companySettingsFieldsController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      }
    }
  }).state('companySettings.checklists', {
    url: "/org/:orgId/settings/checklists",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Checklists",
      "subnavOption": "checklists",
      "docketsOption": "checklists"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/checklists.html',
        controller: 'companySettingsChecklistsController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.resources', {
    url: "/org/:orgId/settings/resources",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Resources",
      "subnavOption": "resources",
      "resourcesOption": "resources"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/resources.html',
        controller: 'companySettingsResourcesController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.addressBookTags', {
    url: "/org/:orgId/settings/tags",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Contact Tags",
      "subnavOption": "tags",
      "resourcesOption": "tags"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/addressBookTag.html',
        controller: 'addressBookTagController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.resourceCategories', {
    url: "/org/:orgId/settings/resourcecategories",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Resource Categories",
      "subnavOption": "categories",
      "resourcesOption": "categories"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/categories.html',
        controller: 'companySettingsResourceCategoriesController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.uoms', {
    url: "/org/:orgId/settings/uoms",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, 'home');
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Uoms",
      "subnavOption": "uoms",
      "resourcesOption": "uoms"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/uoms.html',
        controller: 'companySettingsUomsController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.admins', {
    url: "/org/:orgId/settings/admins",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "subnavOption": "admins",
      "pageTitle": "Admins"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/groupSettings/admins.html',
        controller: 'groupSettingsAdminsController'
      },
      'navigation': {
        templateUrl: 'views/pages/companySettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('companySettings.filing', {
    url: "/org/:orgId/settings/filing",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    data: {
      "mainnavOption": "companySettings",
      "pageTitle": "Filing",
      "subnavOption": "filing",
      "docketsOption": "filing"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/groupSettings/filing.html',
        controller: 'groupSettingsFilingController'
      },
      'navigation': {
        templateUrl: 'views/pages/groupSettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.groupContacts', {
    url: "/org/:orgId/group/:groupId/contacts",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    data: {
      "mainnavOption": "contacts",
      "pageTitle": "Contacts",
      "subnavOption": "contacts"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/contacts/contacts.html',
        controller: 'contactsController'
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('main.connections', {
    url: "/org/:orgId/group/:groupId/connections",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    data: {
      "mainnavOption": "connections",
      "pageTitle": "connections",
      "subnavOption": "connections"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/connections/connections.html',
        controller: 'connectionsController'
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('groupSettings', {
    url: "",
    templateUrl: 'views/settingsTemplate.html',
    abstract: true
  }).state('groupSettings.general', {
    url: "/org/:orgId/group/:groupId/settings",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    params: {
      action: null
    },
    data: {
      "mainnavOption": "groupSettings",
      "subnavOption": "general",
      "pageTitle": "Group Settings"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/companySettings/general.html',
        controller: 'groupSettingsGeneralController'
      },
      'navigation': {
        templateUrl: 'views/pages/groupSettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('groupSettings.filing', {
    url: "/org/:orgId/group/:groupId/settings/filing",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', '$stateParams', function (accessControl, $stateParams) {
        return accessControl.ensureCurrentOrgGroup($stateParams.orgId, $stateParams.groupId);
      }]
    },
    data: {
      "mainnavOption": "groupSettings",
      "pageTitle": "Filing",
      "subnavOption": "filing",
      "docketsOption": "filing"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/groupSettings/filing.html',
        controller: 'groupSettingsFilingController'
      },
      'navigation': {
        templateUrl: 'views/pages/groupSettings/nav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('user', {
    url: "",
    templateUrl: 'views/mainTemplate.html',
    abstract: true
  }).state('user.account', {
    url: "/user/account",
    resolve: {
      currentUser: ['accessControl', function (accessControl) {
        return accessControl.currentUser();
      }],
      currentOrg: ['accessControl', function (accessControl) {
        return accessControl.ensureMyDocketbook();
      }]
    },
    data: {
      "mainnavOption": "user",
      "pageTitle": "Account",
      "subnavOption": "account"
    },
    views: {
      'content': {
        templateUrl: 'views/pages/user/account.html',
        controller: 'adminAccountController'
      },
      'navigation': {
        templateUrl: 'views/mainNav.html',
        controller: 'navController'
      },
      'scopeNav': {
        templateUrl: 'views/scopeNav.html',
        controller: 'scopeNavController'
      },
      'bottomBanner': {
        templateUrl: 'views/trialBanner.html',
        controller: 'trialBannerController'
      }
    }
  }).state('preauth', {
    url: "",
    templateUrl: 'views/preAuthTemplate.html',
    abstract: true
  }).state('preauth.docket', {
    url: "/docket/:docketId",
    params: {
      previewMode: true
    },
    views: {
      'content': {
        templateUrl: 'views/pages/preauth/docket.html',
        controller: 'preAuthDocketController'
      }
    }
  });
}]).run(function ($state, $rootScope, $location, accessControl, formatHelper, alertService) {
  $rootScope.urlVersion = "v1";
  $rootScope.alertService = alertService;
  $rootScope.contactSupportError = alertService.contactSupportError;
  $rootScope.formatTimeQuantity = formatHelper.formatTimeQuantity;
  $rootScope.stringifyAddress = formatHelper.stringifyAddress;
  $rootScope.stringifyAddressHtml = formatHelper.stringifyAddressHtml;
  $rootScope.userHasPermission = accessControl.userHasPermission;

  if (window.localStorage) {
    window.localStorage.removeItem("filters");
  }

$rootScope.imMichelle = $rootScope.imMichelle || decodeURIComponent($location.search().imMichelle) == 'true';
    console.log('imMichelle', $rootScope.imMichelle)

  let redirectTo = '';

  if ($location.search().redirectTo) {
    redirectTo = decodeURIComponent($location.search().redirectTo);
  }

  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    let currentUser = accessControl.currentUser();

    // if the user has opt'd into the react beta, redirect them to the react app
    if (currentUser && currentUser.reactBeta && !$rootScope.imMichelle) {
      window.location.href = window.location.href.replace('?applicationId=io.docketbook.webui&authType=session', '').replace('/#/', '/app/');
      return;
    }

    if (toState.name !== 'main.loading' && fromState.name !== 'main.loading' && currentUser == null) {
      event.preventDefault();

      $state.go('main.loading', {
        goToState: JSON.stringify(toState),
        goToParams: JSON.stringify(toParams),
        searchParams: JSON.stringify($location.search()),
        requestedUrl: $location.absUrl(), // this initiates the process of building a return URL if the user is not logged and requries to come back to a specific route.
        redirectTo: redirectTo,
      });

      return;
    }

    if (toState.name == 'preauth.docket' && currentUser != null && currentUser.name.full != 'Anonymous User') {
      event.preventDefault();
      $state.go('main.docketDetail', { docketId: toParams.docketId });
      return;
    }

    if ($state.params.device) {
      $rootScope.device = $state.params.device;
    }

    var currentTrail = fromParams.stateTrail;
    if (currentTrail == null) {
      currentTrail = [];
    }

    var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
    if (storedFilters) {
      if (storedFilters.job != null && storedFilters.job.id != null && toParams.jobId == null && (toState.name == 'main.dockets' || toState.name == 'main.groupFiling' || toState.name == 'main.docketDetail' || toState.name == 'main.groupDockets' || toState.name == 'main.groupDocketDetail')) {
        toParams.jobId = storedFilters.job.id;
        toParams.jobNumber = storedFilters.job.jobNumber;
      }
      if (storedFilters.order != null && storedFilters.order.id != null && toParams.orderId == null && (toState.name == 'main.dockets' || toState.name == 'main.groupDockets' || toState.name == 'main.docketDetail' || toState.name == 'main.groupDocketDetail' || toState.name == 'main.jobs' ||
        toState.name == 'main.groupJobs' || toState.name == 'main.jobDetail' || toState.name == 'main.groupJobDetail' || toState.name == 'main.groupFiling')) {
        toParams.orderId = storedFilters.order.id;
        toParams.orderNumber = storedFilters.order.orderNumber;
      }
      if (storedFilters.fromDate != null) {
        toParams.fromDate = storedFilters.fromDate;
      }
      if (storedFilters.toDate != null) {
        toParams.toDate = storedFilters.toDate;
      }
      if (storedFilters.startToDate != null) {
        toParams.startToDate = storedFilters.startToDate;
      }
      if (storedFilters.startFromDate != null) {
        toParams.startFromDate = storedFilters.startFromDate;
      }
      if (storedFilters.endToDate != null) {
        toParams.endToDate = storedFilters.endToDate;
      }
      if (storedFilters.endFromDate != null) {
        toParams.endFromDate = storedFilters.endFromDate;
      }
      if (storedFilters.customerContact != null) {
        toParams.customerContact = storedFilters.customerContact;
      }
      if (storedFilters.supplierContact != null) {
        toParams.supplierContact = storedFilters.supplierContact;
      }
      if (storedFilters.docketNumber != null) {
        toParams.docketNumber = storedFilters.docketNumber;
      }
      if (storedFilters.author != null) {
        toParams.author = storedFilters.author;
      }
      if (storedFilters.forwarderContact != null) {
        toParams.forwarderContact = storedFilters.forwarderContact;
      }
      if (storedFilters.orderNumber != null) {
        toParams.orderNumber = storedFilters.orderNumber;
      }
      if (storedFilters.customerRefNo != null) {
        toParams.customerRefNo = storedFilters.customerRefNo;
      }
      if (storedFilters.supplierRefNo != null) {
        toParams.supplierRefNo = storedFilters.supplierRefNo;
      }
      if (storedFilters.datesCleared == true) {
        toParams.datesCleared = true;
      }
    }

    if (currentTrail.length > 0 && currentTrail[currentTrail.length - 1].name == toState.name) {
      currentTrail.pop();
    } else if (currentTrail.length > 1 && currentTrail[currentTrail.length - 2].name == toState.name) {
      currentTrail.pop();
      currentTrail.pop();
    } else {
      if (fromState.name != 'main.loading' && fromState.name != "") {
        if (fromState.name != toState.name) {
          var stateAdd = {};
          stateAdd.name = fromState.name;
          if (fromParams.currentOrg == null) {
            stateAdd.myDocketbook = true;
          }
          if (fromState.name == 'main.docketDetail' || fromState.name == 'main.groupDocketDetail') {
            stateAdd.docketId = fromParams.docketId;
          } else if (fromState.name == 'main.jobDetail' || fromState.name == 'main.groupJobDetail') {
            stateAdd.jobId = fromParams.jobId;
          } else if (fromState.name == 'main.groupOrderDetail') {
            stateAdd.orderId = fromParams.orderId;
          }
          if (fromParams.orgId) {
            stateAdd.orgId = fromParams.orgId;
          }
          if (fromParams.groupId) {
            stateAdd.groupId = fromParams.groupId;
          }
          if (toParams.fromTab != null) {
            stateAdd.fromTab = toParams.fromTab;
          }

          currentTrail.push(stateAdd);
        }
      } else {
        currentTrail = [];
      }
    }

    toParams.stateTrail = currentTrail;

    var windowWidth = $(window).width();
    if (windowWidth <= 768) {
      toParams.device = "mobile";
    } else {
      toParams.device = "desktop";
    }

    toParams.currentUser = accessControl.currentUser();
    toParams.currentOrg = accessControl.currentOrg();
    toParams.currentOrgGroup = accessControl.currentOrgGroup();

    if ((toParams.currentUser !== null) && (!toParams.currentUser.redirecting)) {
      var ravenContext = {
        id: toParams.currentUser.id,
        email: toParams.currentUser.emailAddress,
        name: toParams.currentUser.name.full,
      }
      var update = {
        user_id: toParams.currentUser.id,
        user_hash: toParams.currentUser.hash,
      };
      if (toParams.currentOrg !== null) {
        update.company = {
          id: toParams.currentOrg.id,
          name: toParams.currentOrg.name
        }
        //ravenContext.organisationId = toParams.currentOrg.id;
        //ravenContext.organisationName = toParams.currentOrg.name;
      }
      if (toParams.currentOrgGroup !== null) {
        //ravenContext.organisationGroupId = toParams.currentOrgGroup.id;
        //ravenContext.organisationGroupName = toParams.currentOrgGroup.name;
      }
      /*if (Raven) {
        Raven.setUserContext(ravenContext);
      }*/
    }
  });
});



// WEBPACK FOOTER //
// ./src/app.js